import React from 'react'
import { format } from 'date-fns'
import { Button, Spinner, useDimensions } from '@telavita-core/react-design-kit'

import { ScheduleTimeItem } from './components/ScheduleTimeItem/ScheduleTimeItem'

import { Availability } from './types'

import * as S from './styles'

interface QuickScheduleProps {
  availabilities: Availability[]
  selectedDay: string
  setSelectedSchedule: (availability: Availability) => void
  selectedSchedule: Availability
  disableButton: boolean
  onClickToSchedule: () => void
  loadingSubmit: boolean
  isAvailabilitiesEmpty: boolean
}

type ButtonSubmitState = 'DISABLED' | 'SELECTED' | 'LOADING' 

export const QuickSchedule = ({
  availabilities,
  setSelectedSchedule,
  selectedSchedule,
  disableButton,
  onClickToSchedule,
  loadingSubmit,
  isAvailabilitiesEmpty
}: QuickScheduleProps): JSX.Element => {
  const { isMobile } = useDimensions()

  const selectedDateButtonText = selectedSchedule && 
    `${format(selectedSchedule?.startDate, 'dd/MM')} às ${format(selectedSchedule?.startDate, 'HH:mm')}`

  const buttonText: Record<ButtonSubmitState, React.ReactNode> = {
    DISABLED: 'SELECIONE PARA AGENDAR',
    SELECTED: <><b>AGENDAR</b> para {selectedDateButtonText}</>,
    LOADING: (
      <S.SpinnerWrapper>
        <Spinner />
      </S.SpinnerWrapper>
    )
  }

  function onRenderButtonTextStatus() {
    if (loadingSubmit) {
      return buttonText.LOADING
    }
    if (disableButton) {
      return buttonText.DISABLED
    }
    return buttonText.SELECTED
  }

  return (
    <S.Container isMobile={isMobile}>
      <S.Grid id='showcaseSchedulesId' isMobile={isMobile}>
        {availabilities && availabilities?.map((availability, index) => {
          return (
            <ScheduleTimeItem
              key={index}
              availability={availability}
              setSelectedSchedule={setSelectedSchedule}
              selectedSchedule={selectedSchedule}
              isEmpty={isAvailabilitiesEmpty}
            />
          )
        }
        )}
      </S.Grid>
      <Button 
        onClick={loadingSubmit ? null : () => onClickToSchedule()}
        disabled={disableButton}
        uppercase={false}
        variant='contained'
      >
        {onRenderButtonTextStatus()}
      </Button>
    </S.Container>
  )
}